import { render, staticRenderFns } from "./checkbox-tags.vue?vue&type=template&id=34f78b3c&scoped=true&"
import script from "./checkbox-tags.vue?vue&type=script&lang=js&"
export * from "./checkbox-tags.vue?vue&type=script&lang=js&"
import style0 from "./checkbox-tags.vue?vue&type=style&index=0&id=34f78b3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f78b3c",
  null
  
)

export default component.exports